import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import { State, getCurrentUser } from '../../../../../store';
import { HeaderNavigation } from '../header-navigation.types';

interface MonitoringLink {
  Name: string;
  URL__c: string;
}

// Add docs please

/**
 * Loads the monitoring navigation items for the header.
 * Based on the user's monitoring system links and Orion/Okta credentials.
 * @returns The monitoring navigation items for the header.
 */
export const monitoringNavigationLoader: HeaderNavigation.Loader = () => {
  const store$ = inject<Store<State>>(Store);
  const user$ = store$.select(getCurrentUser);

  return user$.pipe(
    map((user) => {
      const children: HeaderNavigation.Item[] = [];
      const linksFromSalesforce = (user?.Monitoring_System_Links__r?.records ??
        []) as unknown as MonitoringLink[];

      children.push(
        ...linksFromSalesforce.map((link) => ({
          ariaLabel: `Navigate to ${link.Name}`,
          pathname: link.URL__c,
          label: link.Name,
        })),
      );

      if (user?.Orion_UserID__c?.length && user?.Orion_Password__c?.length) {
        children.push({
          ariaLabel: 'Navigate to Managed Routers',
          pathname: `https://vigil.nitelusa.com/Orion?AccountID=${user.Orion_UserID__c}&Password=${user.Orion_Password__c}`,
          label: 'Managed Routers',
        });
      }

      if (
        user?.OktaUsername__c?.length &&
        user?.Account?.Okta_Login_Enabled__c &&
        user.Account?.MCID__c?.length
      ) {
        children.push({
          ariaLabel: 'Navigate to ISC',
          pathname: environment.iscUrl,
          label: 'ISC',
        });
      }

      return {
        label: 'Monitoring',
        ariaLabel: 'Monitoring Group',
        children,
      };
    }),
  );
};
